import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear all authentication data
    localStorage.removeItem("auth");
    localStorage.removeItem("instituteData");
    localStorage.removeItem("currentView");
    localStorage.removeItem("tempInstituteData");
    localStorage.removeItem("isAdminViewingTemp");
    navigate("/");
  };

  const handleViewApplications = () => {
    // Check user role and navigate accordingly
    const auth = JSON.parse(localStorage.getItem("auth") || "{}");
    
    if (auth?.isAdmin) {
      navigate("/ViewSentApplication"); // Admin view
    } else {
      navigate("/ViewSentApplicationInst"); // Institute view
    }
  };

  const handleApplicationForm = () => {
    navigate("/simApp");
  };

  return (
    <header style={styles.header}>
      {/* Left: Main title */}
      <h1 style={styles.title}>EIIN SIM Application</h1>

      {/* Center: Subtitle */}
      <h2 style={styles.subtitle}>Bangladesh Technical Education Board</h2>

      {/* Right: Buttons */}
      <div style={styles.buttonContainer}>
        <button 
          style={styles.formBtn} 
          onClick={handleApplicationForm}
        >
          <span style={styles.icon}>📝</span> আবেদন ফর্ম
        </button>
        <button 
          style={styles.viewBtn} 
          onClick={handleViewApplications}
        >
          <span style={styles.icon}>📋</span> সকল আবেদন
        </button>
        <button style={styles.logoutBtn} onClick={handleLogout}>
          <span style={styles.icon}>🚪</span> Logout
        </button>
      </div>
    </header>
  );
};

// Inline styles
const styles = {
  header: {
    background: "#0a74b9",
    color: "white",
    padding: "15px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    flexWrap: "wrap", // Allow wrapping on smaller screens
  },
  title: {
    fontSize: "20px",
    margin: 0,
    zIndex: 1,
  },
  subtitle: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "14px",
    fontWeight: "normal",
    margin: 0,
    whiteSpace: "nowrap", // Prevent wrapping
  },
  buttonContainer: {
    display: "flex",
    gap: "10px",
    zIndex: 1,
  },
  formBtn: {
    backgroundColor: "#ffc107", // Yellow color
    color: "#333",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background 0.2s ease",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontWeight: "500",
  },
  viewBtn: {
    backgroundColor: "#28a745", // Green color
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background 0.2s ease",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontWeight: "500",
  },
  logoutBtn: {
    backgroundColor: "#dc3545", // Red color
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background 0.2s ease",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontWeight: "500",
  },
  icon: {
    fontSize: "16px",
  },
};

// Add media query for responsive design
const mediaStyles = `
  @media (max-width: 768px) {
    header {
      flex-direction: column;
      gap: 10px;
    }
    .subtitle {
      position: static;
      transform: none;
      margin: 5px 0;
    }
  }
`;

// Add styles to document
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = mediaStyles;
  document.head.appendChild(style);
}

export default Header;